import React from "react";
import Link from "theme/components/atoms/Typography/Link";

const LinkComponent = ({ href, ...rest }) => {
  const { className } = rest;
  const modifiers =
    className &&
    className.split(" ").reduce((acc, cur) => ({ ...acc, [cur]: true }), {});

  const isExternal = !href || /^(https?:)?\/\//.test(href);
  const isSpecialLink = !isExternal && /^.+:/.test(href);

  if (!isSpecialLink) {
    return <Link to={href} {...modifiers} external={isExternal} {...rest} />;
  } else {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a href={href} {...rest} className={className} />;
  }
};

export default LinkComponent;
